import { css, styled } from "@mui/material";

/** Styles for longer portions of text. */
export const Copy = styled("div")(({ theme }) => css`
	display: flex;
	flex-direction: column;
	
	* {
		margin-block: 0;
	}
	
	> * + * {
		margin-top: var(--copy-flex-space, 1rem);
	}
	
	ol, ul {
		padding-left: ${theme.spacing(4)};
		margin-block: ${theme.spacing(.5)};
	}
	
	ol {
		list-style: decimal;
	}
	
	ul {
		list-style: disc;
	}
	
	strong {
		font-weight: 500;
	}
	
	a {
		text-decoration: underline;
	}
	
	&.smallText {
		font-size: .75rem;
	}
`);
